document.addEventListener("DOMContentLoaded", function () {
  let selectedVariantId = null;

  const colorButtons = document.querySelectorAll(
    ".flash-forward_colors-button"
  );

  function toggleSelection(buttons, selectedButton, updateIdFunction) {
    buttons.forEach((button) => button.classList.remove("selected"));
    selectedButton.classList.add("selected");
    updateIdFunction?.(selectedButton);
  }

  const handleButtonClick = (buttons, updateIdFunction) => {
    buttons.forEach((button) => {
      button.addEventListener("click", (e) => {
        e.preventDefault();
        toggleSelection(buttons, button, updateIdFunction);
      });
    });
  };

  handleButtonClick(colorButtons, (selectedButton) => {
    selectedVariantId = selectedButton.getAttribute("data-variant-id");
    const selectedColor = selectedButton.dataset.color.toLowerCase();
    const colorChangeEvent = new CustomEvent("colorChange", {
      detail: { color: selectedColor },
    });
    document.dispatchEvent(colorChangeEvent);

    // Tracking: Shopify only fires product_viewed on a full page load, so a
    // client-side colour switch would otherwise never push a view event to
    // the data layer. Mirror the pixel's view_item_stape for the new variant.
    if (typeof window.tinCanPushViewItem === "function") {
      window.tinCanPushViewItem(selectedVariantId);
    }
  });

  // Listen for color changes and update first bundle dropdown
  document.addEventListener("colorChange", function(event) {
    const selectedColor = event.detail.color;
    
    // Map color button colors to dropdown option text
    const colorMapping = {
      'answer me aquamarine': 'Answer Me Aquamarine',
      'static white': 'Static White', 
      'landline lemon': 'Landline Lemon',
      'later alligator lilac': 'Later Alligator Lilac'
    };
    
    const dropdownOptionText = colorMapping[selectedColor];
    
    if (dropdownOptionText) {
      // Find the currently selected/checked tier
      const checkedTier = document.querySelector('.koala-deal__tier__input:checked+.koala-deal__tier');
      
      if (checkedTier) {
        // Find the dropdown in the checked tier
        const dropdown = checkedTier.querySelector('koala-dropdown');
        
        if (dropdown) {
          // Find the dropdown item that matches the selected color
          const targetItem = dropdown.querySelector(`.koala-dropdown-item[data-value="${dropdownOptionText}"]`);
          
          if (targetItem) {
            // Simulate click on the target dropdown item
            targetItem.click();
            
          } else {
          }
        } else {
        }
      } else {
      }
    } else {
    }
  });

  // Koala Bundles quantity monitoring
  document.querySelectorAll('.koala-deal__tier__quantity-container').forEach((container, index) => {
    const input = container.querySelector('input.koala-deal__quantity-input');
    const incBtn = container.querySelector('.koala-deal__quantity-button[data-type="increment"]');
    const decBtn = container.querySelector('.koala-deal__quantity-button[data-type="decrement"]');
    const addToCartBtn = document.getElementById('add-to-cart-btn');

    const updateBtnText = () => {
      const qty = parseInt(input.value) || 1;
      if (addToCartBtn) {
        addToCartBtn.textContent = `Add ${qty} to cart`;
      }
    };

    if (input) {
      input.addEventListener('change', updateBtnText);
      input.addEventListener('input', updateBtnText); // for live typing
    }
    if (incBtn) {
      incBtn.addEventListener('click', () => {
        setTimeout(updateBtnText, 10);
      });
    }
    if (decBtn) {
      decBtn.addEventListener('click', () => {
        setTimeout(updateBtnText, 10);
      });
    }

    // Initialize button label on load
    updateBtnText();
  });

  // Update add to cart button when tier input checkbox changes
  document.querySelectorAll('.koala-deal__tier__input').forEach(tierInput => {
    tierInput.addEventListener('change', function() {
      if (this.checked) {
        // Find the associated tier (next sibling)
        const tier = this.nextElementSibling;
        
        if (tier && tier.classList.contains('koala-deal__tier')) {
          // Add a short delay to ensure Koala Bundles has updated the DOM
          setTimeout(() => {
            // Find the quantity input globally since there's only one on the page
            const quantityInput = document.querySelector('input.koala-deal__quantity-input');
            const addToCartBtn = document.getElementById('add-to-cart-btn');
            
            if (quantityInput) {
              const quantity = parseInt(quantityInput.value) || 1;
              
              if (addToCartBtn) {
                addToCartBtn.textContent = `Add ${quantity} to cart`;
              }
            }
          }, 100); // 100ms delay to let Koala Bundles update
        }
      }
    });
  });

  // Add + and - CTA buttons to each koala-deal__tier
  document.querySelectorAll('.koala-deal__tier').forEach((tier, index) => {
    // Check if buttons already exist to avoid duplicates
    if (tier.querySelector('.custom-tier-buttons')) {
      return;
    }

    // Create container for the buttons
    const buttonContainer = document.createElement('div');
    buttonContainer.className = 'custom-tier-buttons';

    // Create increment button
    const incrementBtn = document.createElement('button');
    incrementBtn.innerHTML = '+';
    incrementBtn.className = 'custom-tier-increment';
    
    // Create decrement button
    const decrementBtn = document.createElement('button');
    decrementBtn.innerHTML = '-';
    decrementBtn.className = 'custom-tier-decrement';

    // Add click functionality
    incrementBtn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      
      // Try using jQuery if available, otherwise fallback to vanilla JS
      if (typeof $ !== 'undefined' || typeof jQuery !== 'undefined') {
        const $ = window.$ || window.jQuery;
        const $originalIncrementBtn = $('.koala-deal__quantity-button[data-type="increment"]');
        
        if ($originalIncrementBtn.length > 0) {
          $originalIncrementBtn.click();
        } else {
          // Fallback to manual quantity update
          const quantityInput = tier.querySelector('input.koala-deal__quantity-input');
          if (quantityInput) {
            const currentValue = parseInt(quantityInput.value) || 0;
            quantityInput.value = currentValue + 1;
            quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
            quantityInput.dispatchEvent(new Event('input', { bubbles: true }));
          }
        }
      } else {
        // Simulate click on the original Koala Bundles increment button
        const originalIncrementBtn = tier.querySelector('.koala-deal__quantity-container .koala-deal__quantity-button[data-type="increment"]');
        if (originalIncrementBtn) {
          originalIncrementBtn.click();
        } else {
          // Fallback to manual quantity update if original button not found
          const quantityInput = tier.querySelector('input.koala-deal__quantity-input');
          if (quantityInput) {
            const currentValue = parseInt(quantityInput.value) || 0;
            quantityInput.value = currentValue + 1;
            quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
            quantityInput.dispatchEvent(new Event('input', { bubbles: true }));
          }
        }
      }
    });

    decrementBtn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      
      // Try using jQuery if available, otherwise fallback to vanilla JS
      if (typeof $ !== 'undefined' || typeof jQuery !== 'undefined') {
        const $ = window.$ || window.jQuery;
        const $originalDecrementBtn = $('.koala-deal__quantity-button[data-type="decrement"]');
        
        if ($originalDecrementBtn.length > 0) {
          $originalDecrementBtn.click();
        } else {
          // Fallback to manual quantity update
          const quantityInput = tier.querySelector('input.koala-deal__quantity-input');
          if (quantityInput) {
            const currentValue = parseInt(quantityInput.value) || 0;
            const newValue = Math.max(0, currentValue - 1); // Don't go below 0
            quantityInput.value = newValue;
            quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
            quantityInput.dispatchEvent(new Event('input', { bubbles: true }));
          }
        }
      } else {
        // Simulate click on the original Koala Bundles decrement button
        const originalDecrementBtn = tier.querySelector('.koala-deal__quantity-container .koala-deal__quantity-button[data-type="decrement"]');
        if (originalDecrementBtn) {
          originalDecrementBtn.click();
        } else {
          // Fallback to manual quantity update if original button not found
          const quantityInput = tier.querySelector('input.koala-deal__quantity-input');
          if (quantityInput) {
            const currentValue = parseInt(quantityInput.value) || 0;
            const newValue = Math.max(0, currentValue - 1); // Don't go below 0
            quantityInput.value = newValue;
            quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
            quantityInput.dispatchEvent(new Event('input', { bubbles: true }));
          }
        }
      }
    });

    // Add buttons to container
    buttonContainer.appendChild(decrementBtn);
    buttonContainer.appendChild(incrementBtn);

    // Add container to tier
    tier.appendChild(buttonContainer);
  });

  // Add listener to show/hide custom buttons based on tier input state
  function updateButtonVisibility() {
    document.querySelectorAll('.koala-deal__tier__input').forEach(input => {
      const tier = input.nextElementSibling; // The .koala-deal__tier that follows the input
      if (tier && tier.classList.contains('koala-deal__tier')) {
        const customButtons = tier.querySelector('.custom-tier-buttons');
        const variantGroups = tier.querySelector('.koala-deal__tier__variant-groups');
        
        if (customButtons) {
          // When input is checked, variant groups are hidden (tier is selected), so SHOW buttons
          // When input is not checked, variant groups are visible (tier not selected), so HIDE buttons
          if (input.checked) {
            customButtons.style.display = 'flex';
          } else {
            customButtons.style.display = 'none';
          }
        }
      }
    });
  }

  // Add event listeners to all tier inputs
  document.querySelectorAll('.koala-deal__tier__input').forEach(input => {
    input.addEventListener('change', updateButtonVisibility);
  });

  // Initialize button visibility on load
  updateButtonVisibility();

  // Watch for dynamically added tier inputs
  const tierObserver = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'childList') {
        // Check for new tier inputs and add listeners
        document.querySelectorAll('.koala-deal__tier__input:not([data-listener-added])').forEach(input => {
          input.setAttribute('data-listener-added', 'true');
          input.addEventListener('change', updateButtonVisibility);
        });
        updateButtonVisibility();
      }
    });
  });

  tierObserver.observe(document.body, {
    childList: true,
    subtree: true
  });

  // Handle Add to Cart button click with delay to prevent race condition
const addToCartButton = document.querySelector(".flash-forward__button-cart");
addToCartButton.addEventListener("click", function (e) {
  e.preventDefault();
  setTimeout(() => {
    addSelectedVariantsToCart();
  }, 150); // Delay allows dropdowns to finalize their selection
});

  // Custom function to scan and add selected variants to cart
  function addSelectedVariantsToCart() {
    const selectedItems = [];
    
    // Find the single checked tier
    const checkedTier = document.querySelector('.koala-deal__tier__input:checked + .koala-deal__tier');
    
    if (!checkedTier) {
      console.log('No checked tier found');
      alert('Please select a bundle tier before adding to cart.');
      return;
    }
    
    console.log(`=== SCANNING CHECKED TIER ===`);
    
    // Get quantity for this tier
    const quantityContainer = checkedTier.querySelector('.koala-deal__tier__quantity-container');
    const quantityInput = quantityContainer ? quantityContainer.querySelector('.koala-deal__quantity-input') : 
                         document.querySelector('.koala-deal__quantity-input'); // Global fallback
    const tierQuantity = quantityInput ? parseInt(quantityInput.value) || 1 : 1;
    
    console.log(`Tier quantity: ${tierQuantity}`);
    
    // Find all variant groups within this checked tier
    const variantGroups = checkedTier.querySelectorAll('.koala-deal__tier__variant-group');
    console.log(`Found ${variantGroups.length} variant groups in checked tier`);
    
    if (variantGroups.length === 0) {
      console.log('No variant groups found, checking for single dropdown...');
      // Fallback: single dropdown in tier
      const dropdown = checkedTier.querySelector('koala-dropdown');
      if (dropdown) {
        const selectedValue = getDropdownSelectedValueDetailed(dropdown, 1);
        
        if (selectedValue) {
          const variantId = getVariantIdByTitle(selectedValue);
          if (variantId) {
            selectedItems.push({
              id: variantId,
              quantity: tierQuantity,
              title: selectedValue
            });
            console.log(`✓ Added single dropdown variant: "${selectedValue}"`);
          }
        }
      }
    } else {
      // Process each variant group within this checked tier
      variantGroups.forEach((variantGroup, groupIndex) => {
        console.log(`\n--- Processing Variant Group ${groupIndex + 1} ---`);
        
        // Get dropdown from this variant group
        const dropdown = variantGroup.querySelector('koala-dropdown');
        if (dropdown) {
          // Get the selected value from this dropdown
          const selectedValue = getDropdownSelectedValueDetailed(dropdown, groupIndex + 1);
          
          if (selectedValue) {
            const variantId = getVariantIdByTitle(selectedValue);
            
            if (variantId) {
              // Each variant gets quantity 1 (since it's part of a bundle)
              const variantQuantity = 1;
              
              selectedItems.push({
                id: variantId,
                quantity: variantQuantity,
                title: selectedValue
              });
              
              console.log(`✓ Group ${groupIndex + 1}: Added "${selectedValue}" (ID: ${variantId})`);
            } else {
              console.warn(`⚠️ Group ${groupIndex + 1}: Could not map variant ID for "${selectedValue}"`);
            }
          } else {
            console.warn(`⚠️ Group ${groupIndex + 1}: No selected value found`);
          }
        } else {
          console.warn(`⚠️ No dropdown found in Group ${groupIndex + 1}`);
        }
      });
    }
    
    // If no Koala items selected, try fallback to regular product form
    if (selectedItems.length === 0) {
      console.log('No Koala items found, trying fallback methods...');
      // Try selected color button
      const selectedColorButton = document.querySelector('.flash-forward_colors-button.selected');
      if (selectedColorButton) {
        const variantId = selectedColorButton.getAttribute('data-variant-id');
        const quantityInput = document.querySelector('input[name="quantity"]') ||
                             document.querySelector('.koala-deal__quantity-input') ||
                             document.querySelector('#add-to-cart-btn');
        const quantity = quantityInput && quantityInput.value ? parseInt(quantityInput.value) || 1 : 1;
        
        if (variantId) {
          selectedItems.push({
            id: variantId,
            quantity: quantity,
            title: selectedColorButton.getAttribute('data-color') || 'Selected Color'
          });
        }
      }
      
      // Last resort: try hidden form input
      if (selectedItems.length === 0) {
        const hiddenVariantInput = document.querySelector('input[name="id"]');
        if (hiddenVariantInput && hiddenVariantInput.value) {
          const quantityInput = document.querySelector('input[name="quantity"]');
          const quantity = quantityInput ? parseInt(quantityInput.value) || 1 : 1;
          
          selectedItems.push({
            id: hiddenVariantInput.value,
            quantity: quantity,
            title: 'Default Variant'
          });
        }
      }
    }
    
    // Show final results
    console.log('\n=== FINAL CART ITEMS (Before Consolidation) ===');
    selectedItems.forEach((item, index) => {
      console.log(`${index + 1}. ${item.title} (ID: ${item.id}, Qty: ${item.quantity})`);
    });
    
    // Consolidate duplicate variants into single items with proper quantities
    const consolidatedItems = [];
    const variantMap = new Map();
    
    selectedItems.forEach(item => {
      const key = item.id;
      if (variantMap.has(key)) {
        // Add to existing quantity
        variantMap.get(key).quantity += item.quantity;
      } else {
        // Create new entry
        variantMap.set(key, {
          id: item.id,
          quantity: item.quantity,
          title: item.title
        });
      }
    });
    
    // Convert map back to array
    variantMap.forEach(item => {
      consolidatedItems.push(item);
    });
    
    console.log('\n=== CONSOLIDATED CART ITEMS ===');
    consolidatedItems.forEach((item, index) => {
      console.log(`${index + 1}. ${item.title} (ID: ${item.id}, Qty: ${item.quantity})`);
    });
    
    // Count duplicates for summary
    const variantCounts = {};
    consolidatedItems.forEach(item => {
      variantCounts[item.title] = item.quantity;
    });
    
    console.log('\n=== VARIANT SUMMARY ===');
    Object.entries(variantCounts).forEach(([title, count]) => {
      console.log(`${title}: ${count}x`);
    });
    
    if (consolidatedItems.length === 0) {
      alert('Please select a product variant before adding to cart.');
      return;
    }
    
    // Add consolidated items to cart
    addMultipleItemsToCart(consolidatedItems);
  }

  // Enhanced function with detailed debugging for dropdown reading
  function getDropdownSelectedValueDetailed(dropdown, groupNumber) {
    if (!dropdown) {
      console.log(`  Group ${groupNumber}: No dropdown element found`);
      return null;
    }
    
    console.log(`\n--- Group ${groupNumber} Dropdown Analysis ---`);
    
    // Method 1: Check selected attribute
    let selectedValue = dropdown.getAttribute('selected');
    if (selectedValue) {
      console.log(`  ✓ Method 1 (selected attribute): "${selectedValue}"`);
      return selectedValue;
    } else {
      console.log(`  ✗ Method 1 (selected attribute): null`);
    }
    
    // Method 2: Check the label text (remove swatch if present)
    const label = dropdown.querySelector('.koala-dropdown-label');
    if (label) {
      const labelClone = label.cloneNode(true);
      const swatch = labelClone.querySelector('.color-swatch');
      if (swatch) swatch.remove();
      selectedValue = labelClone.textContent.trim();
      if (selectedValue) {
        console.log(`  ✓ Method 2 (label text): "${selectedValue}"`);
        return selectedValue;
      } else {
        console.log(`  ✗ Method 2 (label text): empty`);
      }
    } else {
      console.log(`  ✗ Method 2: No label found`);
    }
    
    // Method 3: Check for selected dropdown item
    const selectedItem = dropdown.querySelector('.koala-dropdown-item.koala-selected');
    if (selectedItem) {
      const itemClone = selectedItem.cloneNode(true);
      const swatch = itemClone.querySelector('.color-swatch');
      if (swatch) swatch.remove();
      selectedValue = itemClone.textContent.trim();
      if (selectedValue) {
        console.log(`  ✓ Method 3 (selected item): "${selectedValue}"`);
        return selectedValue;
      } else {
        console.log(`  ✗ Method 3 (selected item): empty text`);
      }
    } else {
      console.log(`  ✗ Method 3: No selected item found`);
    }
    
    // Method 4: Check data-selected attribute
    selectedValue = dropdown.getAttribute('data-selected');
    if (selectedValue) {
      console.log(`  ✓ Method 4 (data-selected): "${selectedValue}"`);
      return selectedValue;
    } else {
      console.log(`  ✗ Method 4 (data-selected): null`);
    }
    
    // Method 5: Check for checked radio/input within dropdown
    const checkedInput = dropdown.querySelector('input:checked');
    if (checkedInput) {
      selectedValue = checkedInput.value || checkedInput.getAttribute('data-value');
      if (selectedValue) {
        console.log(`  ✓ Method 5 (checked input): "${selectedValue}"`);
        return selectedValue;
      } else {
        console.log(`  ✗ Method 5 (checked input): no value`);
      }
    } else {
      console.log(`  ✗ Method 5: No checked input found`);
    }
    
    console.log(`  ❌ Group ${groupNumber}: Could not determine selected value`);
    return null;
  }

  // Function to get variant ID by product title/name
  function getVariantIdByTitle(title) {
    // Direct mapping of variant names to IDs
    const variantMapping = {
      'Answer Me Aquamarine': '51863195255149',
      'answer me aquamarine': '51863195255149',
      'Static White': '51863195156845', 
      'static white': '51863195156845',
      'Landline Lemon': '51863195189613',
      'landline lemon': '51863195189613',
      'landlinelemon': '51863195189613',
      'Later Alligator Lilac': '51863195222381',
      'later alligator lilac': '51863195222381'
    };
    
    // First try exact match
    if (variantMapping[title]) {
      return variantMapping[title];
    }
    
    // Try lowercase match
    const lowerTitle = title.toLowerCase();
    if (variantMapping[lowerTitle]) {
      return variantMapping[lowerTitle];
    }
    
    // Try partial matches for any remaining cases
    for (let [variantName, variantId] of Object.entries(variantMapping)) {
      if (variantName.toLowerCase().includes(lowerTitle) || lowerTitle.includes(variantName.toLowerCase())) {
        return variantId;
      }
    }
    
    // Fallback: try to get from color buttons if the mapping fails
    const colorButtons = document.querySelectorAll('.flash-forward_colors-button');
    for (let button of colorButtons) {
      const buttonColor = button.getAttribute('data-color');
      const buttonVariantId = button.getAttribute('data-variant-id');
      
      if (buttonColor && title.toLowerCase().includes(buttonColor.toLowerCase())) {
        return buttonVariantId;
      }
    }
    
    return null;
  }

  // Function to add multiple items to cart
  function addMultipleItemsToCart(items) {
    const formData = {
      items: items
    };

    let navigating = false;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData)
    })
    .then(response => response.json())
    .then(data => {
      // Update cart count or show success message
      showAddToCartSuccess(items);

      // Tracking: this bulk /cart/add.js call never trips Shopify's native
      // product_added_to_cart in time (the redirect below tears down the web-
      // pixel sandbox before it can relay), so push add_to_cart_stape ourselves
      // — matching the pixel's shape — BEFORE navigating. The push is
      // synchronous and the GTM/GA4 tags it fires use sendBeacon, which is
      // unload-safe, so an immediate redirect still delivers it.
      //
      // IMPORTANT: redirect immediately (no setTimeout). A delay here lets the
      // native product_added_to_cart pixel fire on some surfaces (e.g.
      // /pages/connection), which would DOUBLE-count add_to_cart on top of this
      // manual push. The instant redirect keeps the native event suppressed so
      // this push is the single source of truth on every surface.
      if (typeof window.tinCanPushAddToCart === 'function') {
        window.tinCanPushAddToCart(items);
      }

      // Redirect to cart page (preserve locale prefix).
      navigating = true;
      const localeMatch = window.location.pathname.match(/^\/(en-us|en-ca|en-au|en-nz|en-gb)/i);
      const cartUrl = localeMatch ? '/' + localeMatch[1] + '/cart' : '/cart';
      window.location.href = cartUrl;
      })
      .catch((error) => {
      if (!navigating) {
        alert('Error adding items to cart. Please try again.');
      }
    });
  }

  // Function to show success message
  function showAddToCartSuccess(items) {
    const totalQuantity = items.reduce((sum, item) => sum + item.quantity, 0);
    
    // Optional: Update the button text temporarily
    const addToCartBtn = document.querySelector('.flash-forward__button-cart');
    if (addToCartBtn) {
      const originalText = addToCartBtn.textContent;
      addToCartBtn.textContent = 'Added to Cart!';
      addToCartBtn.style.backgroundColor = '#4CAF50';
      
      setTimeout(() => {
        addToCartBtn.textContent = originalText;
        addToCartBtn.style.backgroundColor = '';
      }, 2000);
    }
  }

  // Handle "Read More" toggle with smooth height animation
  const flashForwardSection = document.querySelector(".flash-forward");
  const toggleButton = flashForwardSection?.querySelector(
    ".flash-forward__toggle"
  );
  const textWrapper = flashForwardSection?.querySelector(
    ".flash-forward__text"
  );

  if (toggleButton && textWrapper) {
    let isExpanded = false;
  
    toggleButton.addEventListener("click", () => {
      textWrapper.classList.toggle("flash-forward__text--expanded");
      toggleButton.textContent = isExpanded ? "Read More" : "Read Less";
      isExpanded = !isExpanded;
    });
  }

  // Declare observer variable
  let dropdownObserver;

  // Add classes to koala-dropdown-label based on text content
  function updateDropdownLabelClasses() {
    
    // Temporarily disconnect observer to prevent recursive loops
    if (dropdownObserver) {
      dropdownObserver.disconnect();
    }
    
    // Process dropdown labels
    document.querySelectorAll('.koala-dropdown-label').forEach(label => {
      const text = label.textContent.trim();
      
      // Remove any existing swatch element
      const existingSwatch = label.querySelector('.color-swatch');
      if (existingSwatch) {
        existingSwatch.remove();
      }
      
      // Create and insert swatch for label
      const swatchElement = createSwatchForText(text);
      if (swatchElement) {
        label.insertBefore(swatchElement, label.firstChild);
      }
    });
    
    // Process dropdown items
    document.querySelectorAll('.koala-dropdown-item').forEach(item => {
      const text = item.textContent.trim();
      
      // Remove any existing swatch element
      const existingSwatch = item.querySelector('.color-swatch');
      if (existingSwatch) {
        existingSwatch.remove();
      }
      
      // Create and insert swatch for dropdown item
      const swatchElement = createSwatchForText(text);
      if (swatchElement) {
        item.insertBefore(swatchElement, item.firstChild);
      }
    });
    
    // Reconnect observer after changes are complete
    if (dropdownObserver) {
      dropdownObserver.observe(document.body, {
        childList: true,
        subtree: true,
        characterData: true
      });
    }
  }

  // Helper function to create swatch based on text content
  function createSwatchForText(text) {
    let swatchElement = null;
    switch(text) {
      case 'Answer Me Aquamarine':
        swatchElement = createSwatch('aquamarine');
        break;
      case 'Static White':
        swatchElement = createSwatch('staticwhite');
        break;
      case 'Landline Lemon':
        swatchElement = createSwatch('landlinelemon');
        break;
      case 'Later Alligator Lilac':
        swatchElement = createSwatch('lilac');
        break;
      default:
    }
    return swatchElement;
  }

  // Function to create a swatch element
  function createSwatch(colorClass) {
    const swatch = document.createElement('span');
    swatch.className = `color-swatch ${colorClass}`;
    return swatch;
  }

  // Initial update
  updateDropdownLabelClasses();

  // Watch for changes to dropdown labels
  dropdownObserver = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      // Check if the mutation affected a dropdown label or dropdown item
      if (mutation.type === 'childList' || mutation.type === 'characterData') {
        const target = mutation.target;
        
        // If the target or any of its parents is a dropdown label or dropdown item, update classes
        if (target.classList && (target.classList.contains('koala-dropdown-label') || target.classList.contains('koala-dropdown-item'))) {
          updateDropdownLabelClasses();
        } else if (target.closest && (target.closest('.koala-dropdown-label') || target.closest('.koala-dropdown-item'))) {
          updateDropdownLabelClasses();
        } else if (mutation.type === 'childList') {
          // Check if any new dropdown labels or items were added
          const hasDropdownElements = target.querySelector && (target.querySelector('.koala-dropdown-label') || target.querySelector('.koala-dropdown-item'));
          if (hasDropdownElements) {
            updateDropdownLabelClasses();
          }
        }
      }
    });
  });

  // Start observing the document for changes
  dropdownObserver.observe(document.body, {
    childList: true,
    subtree: true,
    characterData: true
  });

  // Remove .00 decimals from Koala Bundles prices
  let koalaPriceObserver;

  function formatKoalaPrices() {
    // Disconnect observer to prevent infinite loop
    if (koalaPriceObserver) {
      koalaPriceObserver.disconnect();
    }

    const priceSelectors = [
      '.koala-deal__tier__price',
      '.koala-deal__tier__regular-price',
      '.koala-deal__tier__badge'
    ];

    priceSelectors.forEach(selector => {
      document.querySelectorAll(selector).forEach(el => {
        // Only modify if .00 is present to avoid unnecessary changes
        if (el.textContent.includes('.00')) {
          el.textContent = el.textContent.replace(/\.00(?=\s|$)/g, '');
        }
      });
    });

    // Reconnect observer after changes
    const koalaDealElement = document.querySelector('koala-deal');
    if (koalaPriceObserver && koalaDealElement) {
      koalaPriceObserver.observe(koalaDealElement, {
        childList: true,
        subtree: true
      });
    }
  }

  // Initial format
  formatKoalaPrices();

  // Watch for Koala Bundles dynamic updates
  koalaPriceObserver = new MutationObserver(formatKoalaPrices);
  const koalaDealElement = document.querySelector('koala-deal');
  if (koalaDealElement) {
    koalaPriceObserver.observe(koalaDealElement, {
      childList: true,
      subtree: true
    });
  }

});
